import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { ErrorPageProps } from './type'

import { CustomHttpErrorMessage } from '@/components/features/error'
import { PageWithHeader, PageWrapper } from '@/components/layout'
import { LinkButton } from '@/components/ui'
import { ROUTE } from '@/const'

const getErrorMessage = (statusCode: ErrorPageProps['statusCode'], t: any) => {
  if (statusCode === undefined) return t('pages.error.messages.default')
  if ([401, 403, 404, 500].includes(statusCode)) {
    return t(`pages.error.messages.${statusCode}`)
  }
  return t('pages.error.messages.default')
}

export const ErrorPage = ({ statusCode, message }: ErrorPageProps) => {
  const { t } = useTranslation()

  const showLinkButton = useMemo(
    () => statusCode === 401 || statusCode === 403,
    [statusCode]
  )

  return (
    <PageWithHeader withSearch={true}>
      <PageWrapper withBreadcrumb={false} spacingX={'sm'} pcWidth={'half'}>
        <div className={clsx('tw-py-2', 'tw-text-center')}>
          {message ? (
            <CustomHttpErrorMessage message={message} />
          ) : (
            <>
              <p className={clsx('tw-text-sm')}>{t('pages.error.title')}</p>
              {statusCode && (
                <h1 className={clsx('tw-mt-1 tw-text-3xl tw-font-bold')}>
                  {statusCode}
                </h1>
              )}
              <p
                className={clsx(
                  'tw-mt-8 tw-whitespace-pre-wrap tw-text-sm tw-leading-8'
                )}
              >
                {getErrorMessage(statusCode, t)}
              </p>
              {showLinkButton && (
                <div className={clsx('tw-mt-20')}>
                  <LinkButton size="lg" href={ROUTE.login}>
                    {t('pages.error.loginButton')}
                  </LinkButton>
                </div>
              )}
            </>
          )}
        </div>
      </PageWrapper>
    </PageWithHeader>
  )
}
